import {AfterViewInit, Component, OnInit} from '@angular/core';
import {NavigationEnd, Route, Router} from '@angular/router';
import {Location} from '@angular/common';
import {Store} from '@ngrx/store';
import * as settings from '../../store/settings';
import {MinifyNavigationService} from '../../core/minify-navigation/minify-navigation.service';


@Component({
    selector: 'smart-grid-view',
    templateUrl: './outward-checks.component.html',
    styleUrls: ['./outward-checks.component.css', '../../../assets/scss/_webfonts/fontawesome-pro-master/scss/fa-solid.scss']
})
export class OutwardChecksComponent implements OnInit {

    constructor(
        private location: Location,
        private router: Router,
        private minifyService: MinifyNavigationService) {
        // if (!this.minifyService.isMinify()) {
        //     this.minifyService.changeMinifyState();
        // }

    }

    ngOnInit(): void {

        if (!customElements.get('outward-checks')) {
            const script = document.createElement('script');
            script.src = 'assets/js/grid-module-bundle.js';
            document.body.appendChild(script);
            this.changeUrl();
        } else {
            customElements.upgrade(document.getElementsByTagName('outward-checks').item(0));
            // window.location.reload();
        }

    }


    private changeUrl() {
        if (window.location.pathname === '/modules/checksManagement') {
            setTimeout(() => {
                this.location.replaceState('/modules/checksManagement');
            }, 1000);
        }
    }
}

